import Card from "@mui/material/Card";
import Box from "@mui/material/Box";

import { CHARGE_TYPE, DELIVERY_CHARGES_FIELDS, getItemKey } from "./constants";
import SettingTextField from "../../../components/SettingTextField";
import { ReactComponent as DeleteIcon } from "../../../assets/images/delete1.svg";

const DeliveryChargeCard = ({ index, chargeData, onInputChange, errors, chargeCount, maxRange, currencySymbol }) => {
    return (
        <Card variant="outlined" sx={{ padding: "1rem", marginBottom: "1rem", backgroundColor: "#f9f9f9" }}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 2,
                    gridTemplateColumns: 'repeat(auto-fill, minmax(22rem, 1fr))',
                    width: '100%',
                }}
            >
                <SettingTextField
                    value={chargeData.minDistance ?? ""}
                    setValue={(val) => onInputChange(val, index, DELIVERY_CHARGES_FIELDS.MIN)}
                    required={true}
                    label={"Minimum Distance (in miles)"}
                    labelStyle={styles.labelStyle}
                    border={"1px solid #AAA"}
                    variant={"filled"}
                    error={errors.get(getItemKey(index, DELIVERY_CHARGES_FIELDS.MIN, CHARGE_TYPE.DELIVERY))}
                    editable={false}
                />

                <SettingTextField
                    value={chargeData.maxDistance ?? ""}
                    setValue={(val) => onInputChange(val, index, DELIVERY_CHARGES_FIELDS.MAX)}
                    required={true}
                    label={"Maximum Distance (in miles)"}
                    labelStyle={styles.labelStyle}
                    border={"1px solid #AAA"}
                    variant={"filled"}
                    error={errors.get(getItemKey(index, DELIVERY_CHARGES_FIELDS.MAX, CHARGE_TYPE.DELIVERY))}
                    editable={index === chargeCount - 1}
                    rightView={index === chargeCount - 1 ? <div style={{ color: "#afafaf", fontSize: "0.75rem" }}>Max Range: {maxRange}</div> : null}
                />

                <SettingTextField
                    value={chargeData.price ?? ""}
                    setValue={(val) => onInputChange(val, index, DELIVERY_CHARGES_FIELDS.PRICE)}
                    required={true}
                    label={`Amount${index === 0 ? " (enter 0 for free)" : ""}`}
                    labelStyle={styles.labelStyle}
                    border={"1px solid #AAA"}
                    variant={"filled"}
                    error={errors.get(getItemKey(index, DELIVERY_CHARGES_FIELDS.PRICE, CHARGE_TYPE.DELIVERY))}
                    leftView={<Box>{currencySymbol}</Box>}
                />
            </Box>
        </Card >
    )
}

export default DeliveryChargeCard;

const styles = {
    labelStyle: {
        fontSize: 14,
        fontFamily: "GilroySemiBold",
        textAlign: "left"
    }
};